import { Fragment } from 'react';
import { Box } from '@mui/material';

import RequiredIndicator from '../requiredIndicator';
import { buildRelativeContainerSx, hasRenderableHelperText } from '../../utils/general';

import type { BaseFieldContainerProps } from './types';

export default function BaseFieldContainer({
  children,
  required,
  showRequiredIndicator: showRequiredIndicatorProp,
  disabled,
  helperText,
  error,
  fullWidth,
  sx,
  requiredIndicatorSx,
  alwaysRenderContainer = false,
}: BaseFieldContainerProps) {
  const showRequiredIndicator =
    showRequiredIndicatorProp ?? (Boolean(required) && !disabled);
  const helperPresent = hasRenderableHelperText(helperText);

  if (!showRequiredIndicator && !alwaysRenderContainer && sx == null) {
    return <Fragment>{children}</Fragment>;
  }

  return (
    <Box
      sx={[
        buildRelativeContainerSx(fullWidth),
        ...(sx == null ? [] : Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
      {showRequiredIndicator ? (
        <RequiredIndicator hasHelperText={helperPresent} error={error} sx={requiredIndicatorSx} />
      ) : null}
    </Box>
  );
}
